import React, { useRef, useContext } from 'react';
import Swal from 'sweetalert2';
import '../Contattami/Contattami.css';
import { Passaggio } from "../App"
import {useNavigate} from "react-router-dom"

const Contattami = () => {

  const nome = useRef(null);
  const cognome = useRef(null);
  const email = useRef(null);
  const messaggio = useRef(null);
  const { url } = useContext(Passaggio);
  const link=useNavigate()
  const inviaForm = () => {
    if (!nome.current.value.trim()) {
      Swal.fire({ title: 'Nome obbligatorio!', icon: 'warning', timer: 1500, showConfirmButton: false });
      return;
    }
    if (!cognome.current.value.trim()) {
      Swal.fire({ title: 'Cognome obbligatorio!', icon: 'warning', timer: 1500, showConfirmButton: false });
      return;
    }
    if (!email.current.value.trim()) {
      Swal.fire({ title: 'Email obbligatoria!', icon: 'warning', timer: 1500, showConfirmButton: false });
      return;
    }


    fetch(url + "/invamsg", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + sessionStorage.getItem("token")
      },
      body: JSON.stringify({ nome: nome.current.value.trim(), cognome: cognome.current.value.trim(), email: email.current.value.trim(), messaggio: messaggio.current.value.trim() })
    })
      .then(response => response.json())
      .then((dati) => {
        if (dati.risultato == "ko" || dati.risultato == undefined) {
          Swal.fire({ title: 'Accedi per inviare.', icon: 'warning', timer: 1500, showConfirmButton: false });
          link("/")
        } else {
          Swal.fire({ title: 'Messaggio inviato!', icon: 'success', timer: 1500, showConfirmButton: false });

          nome.current.value = '';
          cognome.current.value = '';
          email.current.value = '';
          messaggio.current.value = '';
        }
      })
      .catch((errore)=>{
        console.log(errore)
      })


  };

  return (
    <div id="layoutWrapper">
      <form>
        <div className="headingsContainer">
          <h1 className="color">Contattami</h1>
          <h2 className="color">Compila il modulo per scriverci</h2>
        </div>
        <div className="mainContainer">
          <label htmlFor="nome">Nome</label>
          <input type="text" ref={nome} placeholder="Inserisci il tuo nome" name="nome" />

          <label htmlFor="cognome">Cognome</label>
          <input type="text" ref={cognome} placeholder="Inserisci il tuo cognome" name="cognome" />

          <label htmlFor="email">Email</label>
          <input type="email" ref={email} placeholder="Inserisci il tuo indirizzo email" name="email" />

          <label htmlFor="messaggio">Messaggio</label>
          <textarea ref={messaggio} name="messaggio">

          </textarea>
          <button type="button" onClick={inviaForm}>Invia</button>
        </div>
      </form>
    </div>
  );
};

export default Contattami;